import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import styled from 'styled-components';
import { Skeleton } from "../Skeleton";
import { getSizeStyles } from "./Avatar";
export function AvatarSkeleton(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      other = _objectWithoutProperties(_ref, ["size"]);

  return /*#__PURE__*/React.createElement(StyledAvatarSkeleton, _extends({
    rounded: true,
    $size: size
  }, other));
}
var StyledAvatarSkeleton = styled(Skeleton).withConfig({
  displayName: "AvatarSkeleton__StyledAvatarSkeleton",
  componentId: "vapor__lkcumz-0"
})(["", ";display:block;"], function (p) {
  return getSizeStyles(p.$size);
});